export enum Role {
  admin = 'admin',
  staff = 'staff',
  referee = 'referee',
}
